<template lang="pug">
	div
		span(v-for="step of maxScore" :style="`display:inline-block;margin-right: 2px;width: ${width}px;height: ${height}px`")
			<svg :width="width" :height="height" :viewBox="`0 0 ${width} ${height}`" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="parsedScore >= step">
				<path d="M6.66667 0L8.62377 4.08431L13.3333 4.58359L9.83333 7.60712L10.7869 12L6.66667 9.78431L2.54644 12L3.5 7.60712L0 4.58359L4.70956 4.08431L6.66667 0Z" :fill="backgroundColor"/>
			</svg>
			<svg :width="width" :height="height" :viewBox="`0 0 ${width} ${height}`" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="(Number.isNaN(parsedScore)) || (step > parsedScore && step - parsedScore != 0.5)">
				<path d="M6.66667 0L8.62377 4.08431L13.3333 4.58359L9.83333 7.60712L10.7869 12L6.66667 9.78431L2.54644 12L3.5 7.60712L0 4.58359L4.70956 4.08431L6.66667 0Z" :fill="backgroundEmptyColor"/>
			</svg>
			<svg :width="width" :height="height" :viewBox="`0 0 ${width} ${height}`" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="step - parsedScore == 0.5">
				<path d="M6.66667 0L8.62378 4.08431L13.3333 4.58359L9.83333 7.60712L10.7869 12L6.66667 9.78431L2.54644 12L3.5 7.60712L0 4.58359L4.70956 4.08431L6.66667 0Z" :fill="backgroundEmptyColor"/>
				<path d="M6.66666 0V9.78431L2.54644 12L3.5 7.60712L0 4.58359L4.70956 4.08431L6.66666 0Z" :fill="backgroundColor"/>
			</svg>
</template>
<script>
export default {
	props: {
		score: {
			type: [Number, String],
			default: 0
		},
		maxScore: {
			type: Number,
			default: 5
		},
		width: {
			type: [Number, String],
			default: 15
		},
		height: {
			type: [Number, String],
			default: 13
		},
		backgroundColor: {
			type: String,
			default: "#333E8B"
		},
		backgroundEmptyColor: {
			type: String,
			default: "#D4D4D4"
		}
	},
	computed: {
		parsedScore(){
			return parseFloat(this.score)
		}
	}
}
</script>
